export default __webpack_public_path__ + "static/media/037-postman.65b6ffe0.svg";